import React from 'react';
import couvert from '../../svg/svg-couvert.svg';
import {useTranslation } from "react-i18next";  

function BookATable() {
    const { t, i18n } = useTranslation();
    return (
    <section id="book-a-table" className="book-a-table">
      <div className="container">        
        <div className="section-title">
          <h2>{t("make-reservation")} <img src={couvert} className="i-couvert" alt="Book a table at Old Tbilisi restaurant"></img></h2>
          <p>{t("book-a-table")}
            
          </p>
        </div>
        <div className="row ">
          <div className="info pb-3">
            <i className="fas fa-map-marker-alt mx-2" data-bs-toggle="modal" data-bs-target="#exampleModalCenter3"></i>
            <i className="fas fa-phone-alt" data-bs-toggle="modal" data-bs-target="#exampleModalCenter" ></i>
            <i className="fa fa-envelope mx-2" data-bs-toggle="modal" data-bs-target="#exampleModalCenter2"></i>  
          </div>
        </div>
        <form action="https://formsubmit.co/info@oldtbilisi.be" method="POST">
          <input type="hidden" name="_subject" value={t("new-reservation")}/>
          <input type="hidden" name="_captcha" value="false"/>
          
          <div className="form-row">
            <p>{t("personal-information")}</p>
            <div className="col-lg-4 col-md-6 form-group">
              <input type="text" name="name" className="form-control" id="name" placeholder={t("your-name")} required/>
            </div>
            <div className="col-lg-4 col-md-6 form-group">
              <input type="email" className="form-control" name="email" id="email" placeholder={t("your-email")} required/>
            </div>
            <div className="col-lg-4 col-md-6 form-group">
              <input type="tel" className="form-control" name="phone" id="phone" placeholder={t("your-phone")} required/>
            </div>
            <div className="col-lg-4 col-md-6 form-group">
              <p>{t("date")}</p>
              <input type="date" className="form-control" name="date"  id="date" placeholder={t("date")} required/>
            </div>
            <div className="col-lg-4 col-md-6 form-group">
              <p>{t("time")}</p>
              <input type="time" className="form-control" name="time" id="time" placeholder="Time" required/>
            </div>
            <div className="col-lg-4 col-md-6 form-group">
             <p>{t("how-many-people")}</p>
              <input type="number" className="form-control" name="people" id="people" placeholder={"# "+ t("of-people")} required/>
            </div>
          </div>
            <div className="form-group">
              <textarea className="form-control" name="message" rows="3" placeholder={t("additional-message")}></textarea>
            </div>      
            <div className="form-group text-center">
              <p>
              {"* " + t("bat-policy-1")}
              <br></br>
              {"* " + t("bat-policy-2")}
              </p>
            </div>         
            <div className="text-center"><button type="submit">{t("book-table")}</button></div>
        </form>
      </div>
    </section>
    )
}

export default BookATable
